import React, { useState, useCallback } from 'react';

import { SaveButton, Toolbar, DeleteButton, useRecordContext } from 'react-admin';

import LinearProgress from '@mui/material/LinearProgress';
import DeleteAlertDialog from '../../../components/DeleteAlertDialog/DeleteAlertDialog';
import RemoveButton from '../../../components/RemoveButton/RemoveButton';
import Loading from '../../../components/Loading/Loading';

const ExercisesUpdateToolbar = ({ loading, uploading, progressImg, progressCueImgs, ...props }) => {
  const record = useRecordContext();

  const [state, setState] = useState({
    isOpen: false,
    dialogRecord: null,
  });

  const deleteExercise = useCallback(() => {
    setState((prev) => ({ ...prev, isOpen: true }));
  }, []);

  const handleCloseModalDelete = useCallback(() => {
    setState((prev) => ({ ...prev, isOpen: false, dialogRecord: null }));
  }, []);

  const renderLoading = () => {
    if (!progressImg && !progressCueImgs) {
      return <Loading open={loading} />;
    }
    return (
      <Loading open={loading}>
        <>
          {progressImg ? (
            <>
              <p>Uploading Exercise Photo {progressImg} %</p>
              <LinearProgress value={progressImg} variant="determinate" />
            </>
          ) : null}
          {progressCueImgs ? (
            <>
              <p>Uploading Form Cue Images {progressCueImgs} %</p>
              <LinearProgress value={progressCueImgs} variant="determinate" />
            </>
          ) : null}
        </>
      </Loading>
    );
  };

  return (
    <>
      {renderLoading()}
      <Toolbar
        {...props}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          background: 'none',
        }}
      >
        <SaveButton
          disabled={uploading}
          label={uploading ? 'Uploading video…' : 'ra.action.save'}
        />
        <RemoveButton variant="contained" deleteExercise={deleteExercise} />
      </Toolbar>
      <DeleteAlertDialog
        title="Delete Exercise"
        subtitle="Are you sure you want to delete  ?"
        description="Exercise will be deleted permanently and removed from all the programs where it appears."
        record={state.dialogRecord}
        open={state.isOpen}
        handleClose={handleCloseModalDelete}
      >
        <DeleteButton redirect="/exercise" record={record} resource="exercise" />
      </DeleteAlertDialog>
    </>
  );
};

export default ExercisesUpdateToolbar;
